export const config = {
    baseURLApi: process.env.REACT_APP_API_ENDPOINT
    //baseURLApi: 'https://api.devtrim.aws.r-eye.io/v2', //'https://api.spaceagelabs.com.sg/v2'
}